import React from "react";
import Card from "../components/Card";
import { Link } from "react-router-dom";

export default function Services() {
  const services = [
    { image: "custom_fab.png", title: "General Metal Fabrication" },
    { image: "plasma.png", title: "Plasma cutting service" },
    { image: "3d_printing.png", title: "3D Printing" },
    { image: "laser_cutting-v2.webp", title: "Laser Cutting Service", badge: "NEW" },
    { image: "proto.png", title: "Prototype Machining" },
    { image: "cad_design.png", title: "CAD Design" },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-12 bg-white dark:bg-gray-900">
      <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800 dark:text-gray-100 mb-10">
        Our Services
      </h1>
      <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
        {services.map(({ image, title, badge }) => {
          const card = (
            <Card key={title} image={require(`../images/${image}`)} title={title} badge={badge} />
          );
          const path = title === "3D Printing" ? "/3dprint" : title === "Laser Cutting Service" ? "/laser-cutting" : title === "Plasma cutting service" ? "/plasma-cutting" : "";
          return path ? (
            <Link key={title} to={path}>
              {card}
            </Link>
          ) : (
            card
          );
        })}
      </div>
    </div>
  );
}
